/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Popular_SignalsInputs */

const en_directory_launch_popular_signals = /** @type {(inputs: Directory_Launch_Popular_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular signals`)
};

const zh_directory_launch_popular_signals = /** @type {(inputs: Directory_Launch_Popular_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门信号`)
};

/**
* | output |
* | --- |
* | "Popular signals" |
*
* @param {Directory_Launch_Popular_SignalsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_popular_signals = /** @type {((inputs?: Directory_Launch_Popular_SignalsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Popular_SignalsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_popular_signals(inputs)
	return zh_directory_launch_popular_signals(inputs)
});
export { directory_launch_popular_signals as "directory.launch.popular_signals" }